import { __assign, __awaiter, __extends, __generator } from "tslib";
import { axiosStockInstance } from '@/setup/axios/AxiosConfig';
import { StockRepo } from '@/core/repositories/StockRepo';

var PurchaseServices =
/** @class */
function (_super) {
  __extends(PurchaseServices, _super);

  function PurchaseServices() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collection = 'purchase';
    _this.version = 'v1';
    return _this; // public downloadPurchaseFile(params: GenericMethod) {
    //   return this.request({...params, url: '/download/purchases'});
    // }
  }

  PurchaseServices.prototype.changeStatus = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.request.call(this, __assign(__assign({}, params), {
          method: 'PATCH'
        }))];
      });
    });
  };

  PurchaseServices.prototype.getAll = function (params) {
    var base64 = btoa(JSON.stringify(params.query));
    var url = "/filter_q?q=" + base64;
    return this.request(__assign(__assign({}, params), {
      url: url
    }));
  };

  return PurchaseServices;
}(StockRepo);

export default new PurchaseServices(axiosStockInstance);